var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center flex-row-reverse"},[_c('div',{staticClass:"col-md-12 col-sm-12 mt-3 mt-lg-0 text-center"})])])])
}]

export { render, staticRenderFns }